import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import RegistrationSuccessPage from "./components/pages/Home/Home";
import RegisterDriverPage from "./components/pages/RegisterPage/RegisterPage";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/register" element={<RegisterDriverPage />} />
        <Route path="/" element={<RegistrationSuccessPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
